import axios from "axios";
import { URL_BASE } from "../helper/constant.js";

export default () => {
  const instance = axios.create({
    baseURL: URL_BASE,
  });
  instance.defaults.headers.common["Authorization"] =
    localStorage.getItem("loginId");
  instance.defaults.headers.common["Accept"] = "application/json";
  instance.defaults.headers.common["Content-Type"] = "application/json";
  instance.interceptors.response.use(
    function (response) {
      // Do something with response data
      // console.log("response=>", response);
      return response;
    },
    function (error) {
      if (error.response && error.response.status == 401) {
        localStorage.clear();
        window.location.href = "/Login";
        // router.push({ path: '/Login' })
      }
      return Promise.reject(error);
    },
  );
  return instance;
};



// WEBPACK FOOTER //
// ./src/services/Api.js